export default __webpack_public_path__ + "static/media/Front-commetcial-Complex.87e9e7c5.jpg";